import React from "react";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";

const withStripe = Component => {
    class WithStripe extends React.Component {
        constructor(props) {
            super(props);

        }

        render() {
            return (
                <Elements stripe={loadStripe('pk_test_51H07plHy0Sx8AKgdpxjvIIKv4jIH2qwiQ4KOvNT80SuUUZ0VhIpwq6QxiDGWTEszZAkuPNuXyXV2n5C9smEi9x8V00jK3sR0gE')}>
                    <Component {...this.props} />
                </Elements>
            )
        }
    }

    return WithStripe;
}

export default withStripe;